<template>
  <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
    <v-row no-gutters class="mx-6">
      <v-col>
        <v-row class="mx-1 mt-6">
          <v-col cols="12" md="6" class="pb-0">
            <v-text-field
              id="contact_field"
              :label="$tc('contact')"
              v-model="sysContact"
              counter
              :error-messages="sysContactErrors"
              @input="$v.sysContact.$touch()"
              @blur="$v.sysContact.$touch()"
            />
          </v-col>

          <v-col cols="12" md="6" class="pb-0">
            <v-text-field
              id="location_field"
              :label="$tc('location')"
              v-model="sysLocation"
              counter
              :error-messages="sysLocationErrors"
              @input="$v.sysLocation.$touch()"
              @blur="$v.sysLocation.$touch()"
            />
          </v-col>

          <v-col cols="12" md="6" class="pt-0">
            <v-text-field
              id="hsm_alias_field"
              :label="$tc('alias')"
              v-model="hsmAlias"
              counter
              :error-messages="hsmAliasErrors"
              @input="$v.hsmAlias.$touch()"
              @blur="$v.hsmAlias.$touch()"
            />
          </v-col>

          <v-col cols="12" md="6" class="pt-0">
            <v-text-field
              id="trap_community_field"
              :label="$tc('trap_community_name')"
              v-model="sysTrapCommunity"
              counter
              :error-messages="sysTrapCommunityErrors"
              @input="$v.sysTrapCommunity.$touch()"
              @blur="$v.sysTrapCommunity.$touch()"
            />
          </v-col>
        </v-row>

        <v-row justify="end" no-gutters class="mx-6 mb-6">
          <v-btn
            id="submit_trap"
            @click="submit"
            color="blue"
            :disabled="$v.$invalid"
            :dark="!$v.$invalid"
          >
            {{ $tc('upload') }}
          </v-btn>
        </v-row>

        <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
          <v-card-title class="pb-0">
            <v-row no-gutters align="center">
              <v-col cols="7">
                {{ $tc('trap') }}
              </v-col>

              <v-col cols="4">
                <v-row justify="end" align="center">
                  <div v-if="netInfo.snmp.targets.length === 4">
                    <span class="grey--text subtitle-2 text-center">
                      {{ $tc('max_targets') }}
                    </span>
                  </div>
                </v-row>
              </v-col>

              <v-col cols="1">
                <v-row no-gutters justify="end">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon v-on="on" @click="refreshData">
                        <v-icon>
                          autorenew
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $tc('refresh') }}
                    </span>
                  </v-tooltip>

                  <div>
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          icon
                          :disabled="netInfo.snmp.targets.length === 4"
                          v-on="on"
                          @click="openAddModal"
                        >
                          <v-icon>
                            add
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{ $tc('add_ip') }}
                      </span>
                    </v-tooltip>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>

          <trap-target-table @deleteIp="openIpDeleteModal" />
        </v-card>
      </v-col>
    </v-row>

    <new-ip-modal
      :open="showAddModal"
      @close="closeAddModal"
    />

    <ip-delete-modal
      :ip="ip"
      :open="showIpDeleteModal"
      @close="closeIpDeleteModal"
    />
  </v-card>
</template>

<script>
import InputsMixin from '@/mixins/inputs'
import TrapTargetTable from './TrapTargetTable.vue'
import { maxLength } from 'vuelidate/lib/validators'
import NewIpModal from './NewIpModal.vue'
import IpDeleteModal from './IpDeleteModal.vue'

export default {
  mixins: [InputsMixin],
  components: {
    TrapTargetTable,
    NewIpModal,
    IpDeleteModal
  },
  data () {
    return {
      hsmAlias: '',
      sysContact: '',
      sysLocation: '',
      sysTrapCommunity: '',
      ip: '',
      showAddModal: false,
      showIpDeleteModal: false
    }
  },
  created () {
    this.getInfo()
  },
  computed: {
    netInfo () {
      return this.$store.state.hsm.netInfo
    },
    statInfo () {
      return this.$store.state.hsm.statInfo
    },
    hsmAliasErrors () {
      const errors = []
      if (!this.$v.hsmAlias.$dirty) return errors
      !this.$v.hsmAlias.maxLength &&
      errors.push(
        this.$t('$validation.max_length', {
          num: this.$v.hsmAlias.$params.maxLength.max
        })
      )
      return errors
    },
    sysTrapCommunityErrors () {
      const errors = []
      if (!this.$v.sysTrapCommunity.$dirty) return errors
      !this.$v.sysTrapCommunity.maxLength &&
      errors.push(
        this.$t('$validation.max_length', {
          num: this.$v.sysTrapCommunity.$params.maxLength.max
        })
      )
      return errors
    },
    sysContactErrors () {
      const errors = []
      if (!this.$v.sysContact.$dirty) return errors
      !this.$v.sysContact.maxLength &&
      errors.push(
        this.$t('$validation.max_length', {
          num: this.$v.sysContact.$params.maxLength.max
        })
      )
      return errors
    },
    sysLocationErrors () {
      const errors = []
      if (!this.$v.sysLocation.$dirty) return errors
      !this.$v.sysLocation.maxLength &&
      errors.push(
        this.$t('$validation.max_length', {
          num: this.$v.sysLocation.$params.maxLength.max
        })
      )
      return errors
    }
  },
  validations () {
    const validation = {}

    validation.hsmAlias = {
      maxLength: maxLength(16)
    }

    validation.sysTrapCommunity = {
      maxLength: maxLength(64)
    }

    validation.sysContact = {
      maxLength: maxLength(255)
    }

    validation.sysLocation = {
      maxLength: maxLength(255)
    }
    return validation
  },
  methods: {
    loadDate () {
      this.$store.dispatch('hsm/getNetInfo')
      this.$store.dispatch('hsm/getStatInfo')
    },
    getInfo () {
      if (this.statInfo.hsm_alias) {
        this.hsmAlias = this.statInfo.hsm_alias
      }

      if (this.netInfo.snmp.sys_contact) {
        this.sysContact = this.netInfo.snmp.sys_contact
      }

      if (this.netInfo.snmp.sys_location) {
        this.sysLocation = this.netInfo.snmp.sys_location
      }

      if (this.netInfo.snmp.community) {
        this.sysTrapCommunity = this.netInfo.snmp.community
      }
    },
    submit () {
      const target0 = this.netInfo.snmp.targets[0] !== undefined ? this.netInfo.snmp.targets[0] : ''
      const target1 = this.netInfo.snmp.targets[1] !== undefined ? this.netInfo.snmp.targets[1] : ''
      const target2 = this.netInfo.snmp.targets[2] !== undefined ? this.netInfo.snmp.targets[2] : ''
      const target3 = this.netInfo.snmp.targets[3] !== undefined ? this.netInfo.snmp.targets[3] : ''

      this.$store
        .dispatch('hsm/set_snmp_config', {
          body: {
            hsm_alias: this.hsmAlias,
            community: this.sysTrapCommunity,
            sys_contact: this.sysContact,
            sys_location: this.sysLocation,
            target0,
            target1,
            target2,
            target3
          }
        })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    openAddModal () {
      this.showAddModal = true
    },
    closeAddModal () {
      this.loadDate()
      this.getInfo()
      this.showAddModal = false
    },
    openIpDeleteModal (item) {
      this.ip = item.target
      this.showIpDeleteModal = true
    },
    closeIpDeleteModal () {
      this.loadDate()
      this.showIpDeleteModal = false
    },
    refreshData () {
      this.loadDate()
    }
  }
}
</script>
